const login = {
  "login.title": "تسجيل الدخول",
  "login.subtitle": "أدخل رقم هاتفك لاستلام كود التحقق",
  "login.phoneLabel": "رقم الهاتف",
  "login.phonePlaceholder": "1234567890",
  "login.phoneHint": "اكتب رقمك بدون الصفر الأول — كود الدولة موجود بالفعل",
  "login.sendOtp": "إرسال كود التحقق",
  "login.sendingOtp": "جاري إرسال كود التحقق...",
  "login.error.phoneRequired": "الرجاء إدخال رقم الهاتف",
  "login.error.phoneIncomplete": "رقم الهاتف غير مكتمل — تأكد من عدد الأرقام الصحيح",
  "login.error.sendFailed": "فشل إرسال كود التحقق",
  "login.backToHome": "العودة للرئيسية",
};

export default login;